import variablesByEnv from './environmentVariablesValues.json'

type JsonPrimitive = string | number | boolean | null

const variablesForEnv = (environment: string): { [index: string]: JsonPrimitive } => {
  return (variablesByEnv as { [index: string]: { [index: string]: JsonPrimitive } })[environment]
}

// This way of selecting the current environment is far from ideal.
// To follow the 12-factors, we build once for (staging and production).
// But we do not have solution to inject variables at runtime, only at build time.
// So at runtime, we are forced to use the only thing that varies consistently: the domain.
const selectEnvironment = (): string => {
  const envByUrl: { [index: string]: string } = {
    'http://localhost:3055': 'development',
    'http://directory-local.swile.co:3055': 'development',
    // e2e testing
    'http://localhost:5017': 'test',
    // jest testing
    'http://localhost:5018': 'test',
    'https://directory-staging.swile.co': 'staging',
    'https://directory.swile.co': 'production',
  }
  const rootUrl = `${location.protocol}//${location.host}`

  if (!envByUrl[rootUrl]) {
    console.error(`Undefined environment based on root url '${rootUrl}', fall back to 'development'.`)
  }
  return envByUrl[rootUrl] || 'development'
}

export const environment = selectEnvironment()
if (environment == 'development') {
  console.log('variablesByEnv', variablesByEnv)
}

// Always return a string, to simplify handling multiple returned types in the caller.
export const environmentVariables = (name: string): string => {
  const variables = name in variablesForEnv(environment) ? variablesForEnv(environment) : variablesForEnv('default')
  const value = variables[name]
  return typeof value === 'string' ? value : JSON.stringify(value)
}
